import { requireMediaDevices } from '../utils/browser.js';

export class Microphone {
  private stream: MediaStream | null = null;

  async start(constraints: boolean | MediaTrackConstraints = true): Promise<MediaStream> {
    const currentTrack = this.getTrack();
    if (currentTrack?.readyState === 'live') return this.stream as MediaStream;
    if (constraints === false) throw new Error('Microphone constraints cannot be false when starting');

    const stream = await requireMediaDevices().getUserMedia({ audio: constraints, video: false });
    this.stop();
    this.stream = stream;
    return stream;
  }

  getStream(): MediaStream | null {
    return this.stream;
  }

  getTrack(): MediaStreamTrack | null {
    return this.stream?.getAudioTracks()[0] ?? null;
  }

  setEnabled(enabled: boolean): void {
    const track = this.getTrack();
    if (track) track.enabled = enabled;
  }

  isEnabled(): boolean {
    const track = this.getTrack();
    return Boolean(track && track.readyState === 'live' && track.enabled);
  }

  stop(): void {
    this.stream?.getTracks().forEach((track) => track.stop());
    this.stream = null;
  }
}

